import { AppTypeDentalOrVision, DentalAndVisionApplication } from '@/application/shared/domain/DentalAndVisionApplication';
import { EnrollmentRepository } from '@/application/shared/domain/EnrollmentRepository';
import { UseCase } from '@/shared/application/UseCase';
import { SfApiResponse } from '@hfc/ui-core';

interface UpdateParams {
  applicationType: AppTypeDentalOrVision;
  application: DentalAndVisionApplication;
  id: string;
  token: string;
}

export class UpdateApplicationUseCase implements UseCase<UpdateParams, SfApiResponse> {

  private repository: EnrollmentRepository;

  public constructor (repository: EnrollmentRepository) {
    this.repository = repository;
  }

  public async run (params: UpdateParams): Promise<SfApiResponse> {
    const { applicationType, application, id, token } = params;

    return await this.repository.updateDentalAndVisionApplication(applicationType, application, id, token);
  }

}
